var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2834 16.7637H6.6167V30.097C6.6167 35.097 8.28337 36.7637 13.2834 36.7637H26.6167C31.6167 36.7637 33.2834 35.097 33.2834 30.097V16.7637Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 11.764V13.4307C35.8334 15.264 34.9501 16.764 32.5001 16.764H7.50008C4.95008 16.764 4.16675 15.264 4.16675 13.4307V11.764C4.16675 9.93066 4.95008 8.43066 7.50008 8.43066H32.5001C34.9501 8.43066 35.8334 9.93066 35.8334 11.764Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.4304H10.2C9.6333 7.81374 9.64997 6.86374 10.25 6.26374L12.6166 3.89707C13.2333 3.2804 14.25 3.2804 14.8666 3.89707L19.4 8.4304Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7833 8.4304H20.5833L25.1166 3.89707C25.7333 3.2804 26.7499 3.2804 27.3666 3.89707L29.7333 6.26374C30.3333 6.86374 30.3499 7.81374 29.7833 8.4304Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8999 16.7637V25.3303C14.8999 26.6637 16.3666 27.447 17.4832 26.7303L19.0499 25.697C19.6166 25.3303 20.3332 25.3303 20.8832 25.697L22.3666 26.697C23.4666 27.4303 24.9499 26.647 24.9499 25.3137V16.7637H14.8999Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.c22b6e9b726d58d56f45d821cbef1ce7.svg";
export { ForwardRef as ReactComponent };